/**
 * Strata Relay — shared SSE connection (see sharedStream.js for auth).
 * Also emits `stream.status` {healthy} events for subscribers that want stream
 * health. Ticketed reconnects resume via ?last_event_id=.
 */
import { createSharedStream } from '@/api/sharedStream';

export const subscribeRelay = createSharedStream({
  path: '/api/relay/stream',
  eventTypes: ['ready', 'resync', 'message.new', 'message.edit', 'message.delete', 'message.reaction', 'typing', 'presence', 'room.new', 'room.updated', 'read.receipt'],
  reportStatus: true,
  replay: true,
});
